(() => {
  let addressDataPromise = null;
  let checkoutInProgress = false;
  let allowNativeSubmit = false;
  let observerScheduled = false;

  const MODULE_SELECTOR = '[data-abbra-address-selector]';
  const PROVINCE_SELECTOR = '[data-abbra-province]';
  const DISTRICT_SELECTOR = '[data-abbra-district]';
  const CHECKOUT_SELECTOR = '#checkout.cart__checkout-button[name="checkout"], button[name="checkout"]';

  const qs = (root, selector) => root?.querySelector(selector) || null;

  function allModules() {
    return Array.from(document.querySelectorAll(MODULE_SELECTOR));
  }

  function controls(root) {
    return {
      province: qs(root, PROVINCE_SELECTOR),
      district: qs(root, DISTRICT_SELECTOR)
    };
  }

  function showMessage(root, text) {
    const el = qs(root, '[data-abbra-address-message]');
    if (!el) return;
    if (text) el.textContent = text;
    el.classList.add('is-visible');
  }

  function hideMessage(root) {
    qs(root, '[data-abbra-address-message]')?.classList.remove('is-visible');
  }

  function setLoading(root, show) {
    qs(root, '[data-abbra-address-loading]')?.classList.toggle('is-visible', Boolean(show));
  }

  function isAddressValid(root) {
    const { province, district } = controls(root);
    return Boolean(province?.value && district?.value && !district.disabled);
  }

  function getDataUrl() {
    return allModules().map((root) => root.dataset.addressDataUrl).find(Boolean) || '';
  }

  async function getAddressData() {
    if (!addressDataPromise) {
      const dataUrl = getDataUrl();
      if (!dataUrl) throw new Error('Adres veri dosyası bulunamadı.');

      addressDataPromise = fetch(dataUrl, {
        headers: { Accept: 'application/json' },
        cache: 'force-cache'
      }).then(async (response) => {
        if (!response.ok) throw new Error('Adres veri dosyası yüklenemedi.');
        return response.json();
      }).catch((error) => {
        addressDataPromise = null;
        throw error;
      });
    }
    return addressDataPromise;
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Sepet okunamadı.');
    return response.json();
  }

  async function saveCartAttributes(provinceValue, districtValue) {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Teslimat İli': provinceValue || '',
          'Teslimat İlçesi': districtValue || ''
        }
      })
    });

    if (!response.ok) throw new Error('Adres bilgileri sepete kaydedilemedi.');
    return response.json();
  }

  function populateProvinces(root, data) {
    const { province } = controls(root);
    if (!province) return;

    const currentValue = province.value;
    province.innerHTML = '<option value="">İl seçiniz</option>';

    Object.keys(data)
      .sort((a, b) => a.localeCompare(b, 'tr'))
      .forEach((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        province.appendChild(option);
      });

    if (currentValue && Object.prototype.hasOwnProperty.call(data, currentValue)) {
      province.value = currentValue;
    }
  }

  function populateDistricts(root, data, provinceValue, districtValue = '') {
    const { district } = controls(root);
    if (!district) return;

    const districts = data[provinceValue] || [];
    district.innerHTML = districts.length
      ? '<option value="">İlçe seçiniz</option>'
      : '<option value="">Önce il seçiniz</option>';

    districts
      .slice()
      .sort((a, b) => a.localeCompare(b, 'tr'))
      .forEach((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        district.appendChild(option);
      });

    district.disabled = districts.length === 0;
    if (districtValue && districts.includes(districtValue)) district.value = districtValue;
  }

  async function applyAddressToAllModules(provinceValue, districtValue = '', sourceRoot = null) {
    const data = await getAddressData();
    for (const root of allModules()) {
      if (root === sourceRoot) continue;
      const { province } = controls(root);
      if (!province) continue;
      province.value = provinceValue || '';
      populateDistricts(root, data, provinceValue || '', districtValue || '');
      if (provinceValue && districtValue) hideMessage(root);
    }
  }

  async function initModule(root, cart = null) {
    if (!root || root.dataset.abbraInitialized === 'true') return;
    root.dataset.abbraInitialized = 'true';
    setLoading(root, true);

    try {
      const [data, currentCart] = await Promise.all([
        getAddressData(),
        cart ? Promise.resolve(cart) : getCart()
      ]);
      if (!root.isConnected) return;

      populateProvinces(root, data);
      const savedProvince = currentCart.attributes?.['Teslimat İli'] || '';
      const savedDistrict = currentCart.attributes?.['Teslimat İlçesi'] || '';
      const { province } = controls(root);

      if (savedProvince && province && Object.prototype.hasOwnProperty.call(data, savedProvince)) {
        province.value = savedProvince;
        populateDistricts(root, data, savedProvince, savedDistrict);
      }
    } catch (error) {
      console.error('ABBRA adres modülü yüklenemedi:', error);
      root.dataset.abbraInitialized = 'false';
      showMessage(root, 'Adres listesi yüklenemedi. Lütfen sayfayı yenileyin.');
    } finally {
      if (root.isConnected) setLoading(root, false);
    }
  }

  async function initAllModules() {
    const pending = allModules().filter((root) => root.dataset.abbraInitialized !== 'true');
    if (!pending.length) return;

    let cart = null;
    try {
      cart = await getCart();
    } catch (error) {
      console.warn('ABBRA sepet bilgileri okunamadı:', error);
    }

    await Promise.all(pending.map((root) => initModule(root, cart)));
  }


  async function createPrefilledCheckoutUrl(provinceValue, districtValue) {
    const cart = await getCart();
    if (!cart.items?.length) throw new Error('Sepet boş.');

    // Cart permalink ürünleri varyant + adet formatında ister. ABBRA ürünlerinde
    // aynı varyant birden fazla satırda bulunursa miktarları birleştiriyoruz.
    const quantities = new Map();
    for (const item of cart.items) {
      const id = String(item.variant_id);
      quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
    }

    const items = Array.from(quantities.entries())
      .map(([id, qty]) => `${id}:${qty}`)
      .join(',');

    const params = new URLSearchParams();

    // Mevcut ABBRA checkout alan eşlemesini koruyoruz:
    // İl -> city, İlçe -> address2. Bu eşleme mağazanın mevcut ödeme
    // ekranında daha önce çalışan davranışı geri getirir.
    params.set('checkout[shipping_address][city]', provinceValue.trim());
    params.set('checkout[shipping_address][address2]', districtValue.trim());
    params.set('checkout[shipping_address][country]', 'Türkiye');

    // Sipariş yönetim panelindeki Ek bilgiler alanı için cart attributes da
    // permalink üzerinde korunur.
    params.set('attributes[Teslimat İli]', provinceValue.trim());
    params.set('attributes[Teslimat İlçesi]', districtValue.trim());

    return `${window.Shopify.routes.root}cart/${items}?${params.toString()}`;
  }

  function moduleForCheckout(checkout) {
    const scope = checkout.closest('.cart-summary__inner, .cart-drawer__summary, .cart-summary, form');
    const scoped = scope?.querySelector(MODULE_SELECTOR);
    if (scoped) return scoped;

    return allModules().find((root) => root.offsetParent !== null) || allModules()[0] || null;
  }

  async function goToCheckout(checkout) {
    if (checkoutInProgress) return;
    const root = moduleForCheckout(checkout);
    if (!root) return;

    if (!isAddressValid(root)) {
      showMessage(root, 'Ödemeye devam etmek için il ve ilçe seçimi yapmalısınız.');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const { province, district } = controls(root);
      setTimeout(() => (province?.value ? district : province)?.focus(), 250);
      return;
    }

    const { province, district } = controls(root);
    checkoutInProgress = true;
    checkout.setAttribute('aria-busy', 'true');

    try {
      await saveCartAttributes(province.value, district.value);
      await applyAddressToAllModules(province.value, district.value, root);

      // Shopify, normal /checkout yönlendirmesinde cart attribute değerlerini
      // teslimat formuna otomatik olarak taşımaz. İl/ilçe alanlarını checkout'a
      // önceden doldurmak için Shopify'ın desteklediği cart permalink checkout
      // parametrelerini kullanıyoruz.
      const url = await createPrefilledCheckoutUrl(province.value, district.value);
      window.location.assign(url);
    } catch (error) {
      console.error('ABBRA checkout hatası:', error);
      checkoutInProgress = false;
      allowNativeSubmit = false;
      checkout.removeAttribute('aria-busy');
      showMessage(root, 'Adres bilgileri kaydedilemedi. Lütfen tekrar deneyin.');
    }
  }

  document.addEventListener('change', async (event) => {
    const root = event.target.closest?.(MODULE_SELECTOR);
    if (!root) return;

    const { province, district } = controls(root);

    try {
      if (event.target.matches(PROVINCE_SELECTOR)) {
        hideMessage(root);
        const data = await getAddressData();
        populateDistricts(root, data, province.value, '');
        await saveCartAttributes(province.value, '');
        await applyAddressToAllModules(province.value, '', root);
      }

      if (event.target.matches(DISTRICT_SELECTOR)) {
        if (isAddressValid(root)) hideMessage(root);
        await saveCartAttributes(province.value, district.value);
        await applyAddressToAllModules(province.value, district.value, root);
      }
    } catch (error) {
      console.error('ABBRA adres güncelleme hatası:', error);
      showMessage(root, 'Adres bilgisi kaydedilemedi. Lütfen tekrar deneyin.');
    }
  });

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest?.(CHECKOUT_SELECTOR);
    if (!checkout) return;
    if (checkoutInProgress) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    const root = moduleForCheckout(checkout);
    if (!root || !isAddressValid(root)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      goToCheckout(checkout);
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    goToCheckout(checkout);
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (allowNativeSubmit && submitter?.matches?.(CHECKOUT_SELECTOR)) {
      allowNativeSubmit = false;
      return;
    }
    if (checkoutInProgress) {
      event.preventDefault();
      return;
    }
    if (!submitter?.matches?.(CHECKOUT_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    goToCheckout(submitter);
  }, true);

  const observer = new MutationObserver((mutations) => {
    const hasNewModule = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches?.(MODULE_SELECTOR) || node.querySelector?.(MODULE_SELECTOR))
      )
    );

    if (!hasNewModule || observerScheduled) return;
    observerScheduled = true;
    queueMicrotask(() => {
      observerScheduled = false;
      initAllModules();
    });
  });

  function start() {
    initAllModules();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
